import { useTranslation } from 'react-i18next';
import { ContentCopyOutlined, MapOutlined, NavigationOutlined } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { openLocation, routeLocation } from '@/utilities/externalMapUtils';
import { isValidLatLong } from '@/utilities/latlong';
import { Target } from '@/tmp';
import SmallTooltip from '@/components/common/SmallTooltip';

import { useNotificationStore } from '@/stores/notificationstore';

export default function CurrentPositionActions({ contentText, target }: { contentText: string; target: Target }) {
  const showNotification = useNotificationStore((state) => state.showNotification);
  const { t } = useTranslation();

  const onCopyToClipboard = async () => {
    await navigator.clipboard.writeText(contentText);
    showNotification('info', t('general.copiedClipboard'), undefined, 3);
  };

  function onOpenExternalMap() {
    if (!target || !target.currentPosition || !isValidLatLong(target.currentPosition)) {
      return;
    }
    openLocation({
      lat: target.currentPosition.latitude,
      lon: target.currentPosition.longitude,
      title: target.target.name,
    });
  }

  function onRouteExternalMap() {
    if (!t || !target.currentPosition || !isValidLatLong(target.currentPosition)) {
      return;
    }
    routeLocation({
      lat: target.currentPosition.latitude,
      lon: target.currentPosition.longitude,
      title: target.target.name,
    });
  }

  return (
    <>
      <SmallTooltip title={t('general.copy')}>
        <IconButton color="primary" size="small" onClick={onCopyToClipboard}>
          <ContentCopyOutlined fontSize="small" />
        </IconButton>
      </SmallTooltip>
      <SmallTooltip title={t('targetMenu.locationOnMap')}>
        <IconButton color="primary" size="small" onClick={onOpenExternalMap}>
          <MapOutlined fontSize="small" />
        </IconButton>
      </SmallTooltip>
      <SmallTooltip title={t('targetMenu.navigateOnMap')}>
        <IconButton color="primary" size="small" onClick={onRouteExternalMap}>
          <NavigationOutlined fontSize="small" />
        </IconButton>
      </SmallTooltip>
    </>
  );
}
